import { render, staticRenderFns } from "./events.page.vue?vue&type=template&id=3388c7f4&scoped=true&"
import script from "./events.page.vue?vue&type=script&lang=js&"
export * from "./events.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3388c7f4",
  null
  
)

export default component.exports